import TableContainer from '@mui/material/TableContainer';
import {
  default as MuiTable,
  type TableProps as MuiTableProps,
} from '@mui/material/Table';

export { default as TableBody } from './TableBody';
export { default as TableCell } from './TableCell';
export { default as TableHead } from './TableHead';
export { default as TableHeadCell } from './TableHeadCell';
export { default as SortableHeadCell } from './SortableHeadCell';
export { default as TableHeadRow } from './TableHeadRow';
export { default as TableRow } from './TableRow';
export { default as OptionsCell } from './OptionsCell';
export { default as SkeletonRow } from './SkeletonRow';
export { default as SkeletonRows } from './SkeletonRows';
export { default as NameLabelCell } from './NameLabelCell';

export type { TableBodyProps } from './TableBody';
export type { TableCellProps } from './TableCell';
export type { TableHeadProps } from './TableHead';
export type { TableHeadCellProps } from './TableHeadCell';
export type { SortableHeadCellProps } from './SortableHeadCell';
export type { TableHeadRowProps } from './TableHeadRow';
export type { TableRowProps } from './TableRow';
export type { OptionsCellProps } from './OptionsCell';
export type { SkeletonRowProps } from './SkeletonRow';
export type { SkeletonRowsProps } from './SkeletonRows';
export type { NameLabelCellProps } from './NameLabelCell';

export interface TableProps extends MuiTableProps {
  className?: string;
}

export default function Table({ className, ...props }: TableProps) {
  return (
    <TableContainer className={className}>
      <MuiTable stickyHeader {...props} />
    </TableContainer>
  );
}
